import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO_CONFIG } from '@/config/seo';

/**
 * HowTo schema for the homepage "Comment ça marche" section.
 * Enables rich results in Google Search for how-to queries related to booking activities.
 * Render on the Index page only, alongside OrganizationJsonLd and WebsiteJsonLd.
 */
export function HowToJsonLd() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: 'Comment réserver une activité indoor à Paris sur FullBook',
    description:
      'Réservez votre activité indoor en Île-de-France en 3 étapes simples : choisissez, réservez en ligne et profitez.',
    url: SEO_CONFIG.baseUrl,
    totalTime: 'PT5M',
    step: [
      {
        '@type': 'HowToStep',
        position: 1,
        name: 'Choisissez une activité',
        text: "Parcourez nos catégories et trouvez l'activité qui vous convient parmi bowling, escape game, karting, laser game, padel et plus encore.",
        url: `${SEO_CONFIG.baseUrl}/search`,
      },
      {
        '@type': 'HowToStep',
        position: 2,
        name: 'Réservez en ligne',
        text: 'Sélectionnez une date, une heure et le nombre de participants en quelques clics, avec disponibilités en temps réel.',
        url: `${SEO_CONFIG.baseUrl}/search`,
      },
      {
        '@type': 'HowToStep',
        position: 3,
        name: "Profitez de l'activité",
        text: "Présentez-vous à l'établissement le jour J avec votre confirmation de réservation et profitez de votre activité !",
        url: `${SEO_CONFIG.baseUrl}/search`,
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
